import '@GiideLearning/giide-feedcards-v3/src/index.css';

import './index.css';

import WebFont from 'webfontloader';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
  concat,
} from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';

import App from './App';
import reducer from './reducers';

WebFont.load({
  custom: {
    families: ['Montserrat Regular', 'Montserrat Medium'],
    urls: ['/index.css'],
  },
});

// SETUP APOLLO FOR CONTACT US API

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GIIDE_API_URL });

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: { 'x-api-key': process.env.REACT_APP_GIIDE_API_KEY },
  });
  return forward(operation);
});

const client = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
});

// END APOLLO SETUP

export const store = createStore(reducer, composeWithDevTools());

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App />
    </Provider>
  </ApolloProvider>,
  document.getElementById('root')
);
